<template>
  <div  class="panel" :style="{ '--scale-factor': scaleFactor }">

    <Header/>
  <div
    v-loading.fullscreen.lock="fullscreenLoading"
    element-loading-text="处理中…… 请耐心等待"
    element-loading-spinner="el-icon-loading"
    class="touGeBox"
  >

    <img :src="require('../assets/bgPro.png')" alt="" width="100%"style="position: absolute;top: 0px;z-index: -99;height: 485px">
    <img :src="require('../assets/bgPros.png')" alt="" width="100%"style="position: absolute;top: 1443px;z-index: -99;height: 682px">
    <img :src="require('../assets/bgPro.png')" alt="" width="100%"style="position: absolute;bottom: 360px;z-index: -99;height: 825px">
    <img :src="require('../assets/bgPro.png')" alt="" width="100%"style="position: absolute;top: 485px;z-index: -99;height: 958px">
    <!--    /* 轮播图 */-->
    <div class="oneTitle">
      <div class="pubTitle">
        在线实验教学数据统计
      </div>
      <div class="pubTitles">
        —— Statistics ——
      </div>
    </div>
    <div style="width: 100%;
    margin:  0 auto;">
      <el-carousel :interval="4000" type="card" height="342px">
        <el-carousel-item v-for="item in carouselList" :key="item" style="background-color: #c6e2ff">
          <div style="width: 100%;height: 100%;display: flex">
            <div style="height: 342px;width: 686px;background-color: #176DAA;position: relative;z-index: -2;">
              <div style="height: 76px;width: 217px;position: absolute;right: 0;top: 0;border-bottom: 6px solid;border-image: linear-gradient(270deg, #FFFFFF 0%, #ffffff00 100%) 1;font-family: MicrosoftYaHei-Bold;
font-weight: 700;
font-size: 32px;
color: #FFFFFF;text-align: center;line-height: 70px;
letter-spacing: 0;">
                {{item.name}}
              </div>
              <div style="width: 100%;height: 100%;font-family: MicrosoftYaHei-Bold;
font-weight: 700;
font-size: 145px;padding-left: 50px;
color: #FFFFFF;line-height: 342px;
letter-spacing: 0;">
                {{item.num}}
              </div>
              <div style="width: 100%;height: 151px;position: absolute;right: 0;bottom: 0;" class="shuiyin3">
<!--                <img :src="require('../assets/shuiyin3.png')" alt="">-->
              </div>
            </div>
            <div style="height: 342px;width: 604px">
              <img :src="item.coverPic" alt="" style="height: 342px;width: 604px">
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="oneTitle">
      <div class="pubTitle">
        开放课程数据统计
      </div>
      <div class="pubTitles">
        —— Statistics ——
      </div>
    </div>

    <div class="courseBox" style="margin-bottom: 5px;height: 850px;">
      <div style="width: 100%;height: 100px;display: flex">
        <div style="width: 32%;height: 100px; border-bottom: 6px solid ;
        box-shadow: 0 6px 12px 0 #0000001f;margin-right: 2%;padding:12px 10px;
      border-image: linear-gradient(270deg, #CED589 0%, #3A7CB5 54%, #FFFFFF 87%, #FFFFFF 100%) 1;display: flex;
      ">
          <div style="width:100px;height: 100%;display: flex;justify-content: center;align-items: center;flex-wrap: wrap">
            <img :src="require('../assets/course1.png')" alt="" style="width: 50px;height: 40px"/>
            <span style="font-family: MicrosoftYaHei-Bold;
font-weight: 700;
font-size: 20px;
color: #333333;margin-top: 6px;
letter-spacing: 0;">开放课程</span>
          </div>
          <div style="width: calc(100% - 180px);font-family: MicrosoftYaHei-Bold;text-align: center;
font-weight: 700;
font-size: 54px;height: 76px;line-height: 76px;
color: #333333;
letter-spacing: 0;">
            {{open_subject_statistics.num}}
          </div>
        </div>
        <div style="width: 32%;height: 100px; border-bottom: 6px solid ;
        box-shadow: 0 6px 12px 0 #0000001f;margin-right: 2%;padding:12px 10px;
      border-image: linear-gradient(270deg, #CED589 0%, #3A7CB5 54%, #FFFFFF 87%, #FFFFFF 100%) 1;display: flex;
      ">
          <div style="width:100px;height: 100%;display: flex;justify-content: center;align-items: center;flex-wrap: wrap">
            <img :src="require('../assets/course2.png')" alt="" style="width: 50px;height: 40px"/>
            <span style="font-family: MicrosoftYaHei-Bold;
font-weight: 700;
font-size: 20px;
color: #333333;margin-top: 6px;
letter-spacing: 0;">累计学期</span>
          </div>
          <div style="width: calc(100% - 180px);font-family: MicrosoftYaHei-Bold;text-align: center;
font-weight: 700;
font-size: 54px;height: 76px;line-height: 76px;
color: #333333;
letter-spacing: 0;">
            {{open_subject_statistics.semester_num}}
          </div>
        </div>
        <div style="width: 32%;height: 100px; border-bottom: 6px solid ;
        box-shadow: 0 6px 12px 0 #0000001f;padding:12px 10px;
      border-image: linear-gradient(270deg, #CED589 0%, #3A7CB5 54%, #FFFFFF 87%, #FFFFFF 100%) 1;display: flex;
      ">
          <div style="width:80px;height: 100%;display: flex;justify-content: center;align-items: center;flex-wrap: wrap">
            <img :src="require('../assets/course3.png')" alt="" style="width: 50px;height: 40px"/>
            <span style="font-family: MicrosoftYaHei-Bold;
font-weight: 700;
font-size: 20px;
color: #333333;margin-top: 6px;
letter-spacing: 0;">学员</span>
          </div>
          <div style="width: calc(100% - 180px);font-family: MicrosoftYaHei-Bold;text-align: center;
font-weight: 700;
font-size: 54px;height: 76px;line-height: 76px;
color: #333333;
letter-spacing: 0;">
            {{open_subject_statistics.member_num}}
          </div>
        </div>
      </div>

      <div style="width: 100%;height: 690px;margin-top: 60px;position: relative">
        <div style="font-family: MicrosoftYaHei-Bold;
font-weight: 700;
font-size: 28px;
color: #666666;
letter-spacing: 0;position: absolute;top: 0;left:50px">学员分布热力图</div>
          <div ref="chinaMap" style="height: 100%;width: 100%"></div>
      </div>

    </div>




    <div class="oneTitle">
      <div class="pubTitle">
        大规模在线考试系统数据统计
      </div>
      <div class="pubTitles">
        —— Statistics ——
      </div>
    </div>

    <div class="courseBox" style="margin-bottom: 45px;height: 530px">
      <div style="width: 100%;height: 530px;display: flex;">
        <div style="width: 48%;height:530px;background-color: #105C93;padding:20px">
          <div style="height:100%;width: 100%;display: flex;flex-wrap: wrap">
            <div style="width: 50%;height: 50%;border-bottom: 1px solid #548AB1;border-right: 1px solid #548AB1;display: flex;justify-content: center;align-items: center;flex-wrap: wrap">
              <img :src="require('../assets/people1.png')" alt="" width="86px" height="86px" />
              <div style="width: 100%;font-family: DINAlternate-Bold;
font-weight: 700;
font-size: 50px;
color: #FFFFFF;margin-top: -40px;
letter-spacing: 5.88px;text-align: center;display: flex;justify-content: center;align-items: center;">
                <span>{{online_exercise_statistics.exercise_user_num}}</span>
                <div style="border-radius: 100px;width: 30px;height: 30px;line-height:30px;background-color: #fff;color:#176DAA;font-size: 20px;margin-left: 8px">
                    <div style="width: 35px;height: 35px">人
                    </div>
                </div>
              </div>
              <div style="width: 100%;font-family: PingFangSC-Semibold;
font-weight: 600;
font-size: 20px;
color: #FFFFFF;margin-top: -45px;
letter-spacing: 2.35px;text-align: center">考试人数</div>
            </div>
            <div style="width: 50%;height: 50%;border-bottom: 1px solid #548AB1;display: flex;justify-content: center;align-items: center;flex-wrap: wrap">
              <img :src="require('../assets/people2.png')" alt="" width="86px" height="86px" />
              <div style="width: 100%;font-family: DINAlternate-Bold;
font-weight: 700;
font-size: 50px;
color: #FFFFFF;margin-top: -40px;
letter-spacing: 5.88px;text-align: center;display: flex;justify-content: center;align-items: center;">
                <span>{{online_exercise_statistics.test_exercise_num}}</span>
                <div style="border-radius: 100px;width: 30px;height: 30px;line-height:30px;background-color: #fff;color:#176DAA;font-size: 20px;margin-left: 8px">
                  <div style="width: 35px;height: 35px">人
                  </div>
                </div>
              </div>
              <div style="width: 100%;font-family: PingFangSC-Semibold;
font-weight: 600;
font-size: 20px;
color: #FFFFFF;margin-top: -45px;
letter-spacing: 2.35px;text-align: center">考试(模拟)</div>
            </div>
            <div style="width: 50%;height: 50%;border-right: 1px solid #548AB1;display: flex;justify-content: center;align-items: center;flex-wrap: wrap">
              <img :src="require('../assets/people3.png')" alt="" width="86px" height="86px" />
              <div style="width: 100%;font-family: DINAlternate-Bold;
font-weight: 700;
font-size: 50px;
color: #FFFFFF;margin-top: -40px;
letter-spacing: 5.88px;text-align: center;display: flex;justify-content: center;align-items: center;">
                <span>{{online_exercise_statistics.normal_exercise_num}}</span>
                <div style="border-radius: 100px;width: 30px;height: 30px;line-height:30px;background-color: #fff;color:#176DAA;font-size: 20px;margin-left: 8px">
                  <div style="width: 35px;height: 35px">人
                  </div>
                </div>
              </div>
              <div style="width: 100%;font-family: PingFangSC-Semibold;
font-weight: 600;
font-size: 20px;
color: #FFFFFF;margin-top: -45px;
letter-spacing: 2.35px;text-align: center">考试(正式)</div>
            </div>
            <div style="width: 50%;height: 50%;display: flex;justify-content: center;align-items: center;flex-wrap: wrap">
              <img :src="require('../assets/people4.png')" alt="" width="86px" height="86px" />
              <div style="width: 100%;font-family: DINAlternate-Bold;
font-weight: 700;
font-size: 50px;
color: #FFFFFF;margin-top: -40px;
letter-spacing: 5.88px;text-align: center;display: flex;justify-content: center;align-items: center;">
                <span>{{online_exercise_statistics.subject_exercise_num}}</span>
                <div style="border-radius: 100px;width: 30px;height: 30px;line-height:30px;background-color: #fff;color:#176DAA;font-size: 20px;margin-left: 8px">
                  <div style="width: 35px;height: 35px">门
                  </div>
                </div>
              </div>
              <div style="width: 100%;font-family: PingFangSC-Semibold;
font-weight: 600;
font-size: 20px;
color: #FFFFFF;margin-top: -45px;
letter-spacing: 2.35px;text-align: center">支持课程</div>
            </div>
          </div>
        </div>
        <div style="width: 52%;height: 530px;">
          <img :src="require('../assets/people5.png')" alt="" width="100%" height="530px" />
        </div>
      </div>
    </div>






    <div class="oneTitle">
      <div class="pubTitle">
        课程统计
      </div>
      <div class="pubTitles">
        —— Course statistics ——
      </div>
    </div>

    <div class="courseBox">
      <div class="courseTitleBox">
        <div v-for="(c,i) in kcList" :key="i" style="text-align: center;position: relative" :class="activeTitleIndex==i?'activeTitleItem':'TitleItem'" @click="changeTitle(i,c)">
          <p class="Title">{{c.num}}</p>
          <p class="className">{{c.name}}</p>
          <div style="position: absolute;bottom: -10px;right: -6px;height: 80px;width: 190px;" class="shuiyin">

          </div>
        </div>
      </div>
      <div class="courseContent">
        <div v-for="(item,index) in courseList" :key="index" :class="activeCourseIndex==index?'activeCourseItem':'courseItem'" @click="changeActiveCourseItem(index,item)">
          <div class="itemTop">
            <img :src="item.image_url" alt="" style="object-fit: cover">
            <div class="subscript" v-if="item.featured=='1'">国家一流</div>
            <div class="subscript1" v-if="item.featured=='3'">省级一流</div>
            <div class="subscript2" v-if="item.featured=='-1'">其他课程</div>
          </div>
          <div class="itemBottom">
            <div class="itemTitle">
              <div style="width: 3%">
                <i class="dividerBlue"></i>
              </div>
              <div style="  width:96%;padding-left: 3px;height: 100%">
                <div>
                  <p style="font-size: 12px;margin-top: 2px;padding: 0">【{{item.featured=='1'?'国家一流':item.featured=='3'?'省级一流':'其他课程'}}】</p>
<!--                  <p style="font-size: 14px;"><i class="el-icon-view" style="margin-right: 4px"></i>8998</p>-->
                </div>
                <div>
                  <p style="font-weight: 700;
                              font-size: 18px;
                              color: #333333;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              white-space: nowrap;
                      "> {{item.name}}</p>
                  <!--                      文字超出两行显示省略号-->
                  <p style="font-size: 16px;
                                line-height: 30px;
                                margin-top: 12px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                word-break: break-all;
                                -webkit-box-orient: vertical"
                     :title="item.description"
                  >
                    {{item.description}}
                  </p>
                </div>
                <hr style="border: 0;border-top: 2px dashed #f7f7f7;margin-top: 15px">
                <div style="display: flex;align-items: center;margin-top: 35px">
                  <div style="width: 200px;">
                    <p class="num">{{item.member_count}}</p>
                    <p class="key">总计学生人数</p>
                  </div>
                  <div>
                    <p class="num">{{item.shixuns_count}}</p>
                    <p class="key">实践项目</p>
                  </div>
                </div>
                <div style="display: flex;align-items: center;margin-top: 35px">
                  <div style="width: 200px;">
                    <p class="num">{{ item.challenge_choose_count }}</p>
                    <p class="key">选择题关卡</p>
                  </div>
                  <div>
                    <p class="num">{{item.challenges_count}}</p>
                    <p class="key">实践关卡</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="position:absolute;right: 0;bottom: 0;width: 174px;height: 80px;" class="shuiyin2">
          </div>
        </div>
      </div>
      <div class="coursePage" style="text-align: center;margin-bottom: 25px">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[6,12,18,24]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 底部快捷链接 -->
    <div class="bottomLink">
      <div style="
            margin: 0 auto;display: flex;
            align-items: center;
            justify-content: center;
            width: 1300px;
            padding: 0 5%;
            height: 60px;
">
        <div
          v-for="(item, index) in friendshipLink.res"
          :key="index"
          class="bottomLinkList"
          :style="{cursor:item.linkName == '中心服务'?'default':'pointer'}"
          @click="goLink(item)"
        >
          <div style="display:flex;align-items: center;">
            <img
              :src="'/mainsys/UserFiles/externalicon/' + item.linkImage"
              style="height: 18px;width: 18px;margin-right:12px;"
            />
            <div style="line-height: 20px;height: 20px;">
              {{ item.linkName }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部版权信息 -->
    <div class="copyDiv">
      <div style="width: 100%;margin: 0 auto;display: flex;
          justify-content: space-between;
          align-items: center;">
        <div class="copyDivLeft">
          <img
            :src="require('../assets/bottomLogo.png')"
            alt=""
            style="width:360px;height:50px;margin-bottom:16px"
          />
          <div class="copyDivLeftCon">建设单位：国防科技大学</div>
          <div class="copyDivLeftCon">支持单位：湖南强智科技发展有限公司</div>
          <div class="copyDivLeftCon">
            推荐使用: Chrome或Firefox等主流浏览器
          </div>
          <div class="copyDivLeftCon">
            Copyright © 1999- 2024 国防科技大学 版权所有
          </div>
          <div class="copyDivLeftCon">
            总计访问次数：{{websiteVisitsNum}} 次 <span style="margin-left: 50px">年度访问次数：{{yearCount}} 次</span>
          </div>
        </div>
        <div
          class="copyDivRight"
          style="text-align:center;width: 140px"
          v-if="friendshipLink.top && friendshipLink.top.length > 0"
        >
          <img
            :src="
              '/mainsys/UserFiles/externalicon/' +
                friendshipLink.top[0].linkImage
            "
            alt=""
            style="width:140px;height:140px;margin:0 auto;text-align: center"
          />
          <div style="font-size: 16px;color: #FAFAFA;margin-top: 16px">
            {{ friendshipLink.top[0].linkName }}
          </div>
        </div>
      </div>
    </div>
<!--    <div class="copyDiv">-->
<!--      <div style="width: 1300px;margin: 0 auto;display: flex;-->
<!--          justify-content: space-between;-->
<!--          align-items: center;">-->
<!--        <div class="copyDivLeft">-->
<!--          <img-->
<!--            :src="require('../assets/bottomLogo.png')"-->
<!--            alt=""-->
<!--            style="width:360px;height:50px;margin-bottom:16px"-->
<!--          />-->
<!--          <div class="copyDivLeftCon">建设单位：国防科技大学</div>-->
<!--          <div class="copyDivLeftCon">支持单位：湖南强智科技发展有限公司</div>-->
<!--          <div class="copyDivLeftCon">-->
<!--            推荐使用: Chrome或Firefox等主流浏览器-->
<!--          </div>-->
<!--          <div class="copyDivLeftCon">-->
<!--            Copyright © 1999- 2024 国防科技大学 版权所有-->
<!--          </div>-->
<!--          <div class="copyDivLeftCon" style="display: flex;justify-content: space-between;align-items: center">-->
<!--            <div style="height: 100px;line-height: 70px;">-->
<!--              网站访问次数：{{websiteVisitsNum}} 次-->
<!--            </div>-->
<!--            <div id="chartLine"  style="width: 200px;height: 100px" ref="chartLine">-->

<!--          </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div-->
<!--          class="copyDivRight"-->
<!--          style="text-align:center;width: 200px"-->
<!--          v-if="friendshipLink.top && friendshipLink.top.length > 0"-->
<!--        >-->
<!--          <img-->
<!--            :src="-->
<!--              '/mainsys/UserFiles/externalicon/' +-->
<!--                friendshipLink.top[0].linkImage-->
<!--            "-->
<!--            alt=""-->
<!--            style="width:140px;height:140px;margin:0 auto;text-align: center"-->
<!--          />-->
<!--          <div style="font-size: 16px;color: #FAFAFA;margin-top: 16px">-->
<!--            {{ friendshipLink.top[0].linkName }}-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--    </div>-->
  </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import Header from "@/views/Header.vue";
import '@/resource/js/chain.js'
export default {
  name: "TouGe",
  data() {
    return{
      fullscreenLoading:false,
      slideShowList:[],
      courseList:[],
      kcList:[],
      websiteVisitsNum:'',
      activeTitleIndex:0,//课程分类默认选中
      activeCourseIndex:0,//课程默认选中
      currentPage:1,//当前页码
      pageSize:6,//每页显示多少条
      total:0,//总条数
      chart:null,//柱状图
      chartData:[],//柱状图数据
      chartXData:[],//柱状图X轴数据
      chartYData:[],//柱状图Y轴数据
      touGeUrl:"",
      type:'',
      courseId:'',
      yearCount:0,
      scaleFactor: 1, // 初始缩放比例
      carouselList:[], // 初始缩放比例
      open_subject_statistics:{}, // 初始缩放比例
      online_exercise_statistics:{}, // 初始缩放比例
    }
  },

  components: {
    Header,
  },
  methods:{
    handleResize() {
      const windowWidth = window.innerWidth;
      const baseWidth = 1920; // 基准宽度
      console.log(windowWidth / baseWidth);
      this.scaleFactor = windowWidth / baseWidth
    },
    goSystem(){
      window.open(this.touGeUrl);
      // window.location.href = this.touGeUrl
    },
    toDetail1(contentId,item){
      if(item.coverUrl){
        window.open(item.coverUrl)
      }
    },
    getAccessLogNum(){
      axios
        .post("/cmsapi/getAccessLogNum").then((res)=>{
        if(res.data.code == '2'){
          this.websiteVisitsNum = res.data.data
          this.yearCount=res.data.yearCount
        }
      })
    },
    getSlideShow() {
      //获取轮播图
      axios.post("/cmsapi/getSlideshow").then(response => {
        let recData = response.data;
        this.slideShowList = recData;
        if (this.slideShowList.length > 0) {
          this.slideShowList.forEach(item => {
            item.coverPic =
              "/mainsys/UserFiles/coverpic/" + item.coverPic;
          })
        } else {
          this.slideShowList = [
            {
              coverPic: require("../assets/banner.jpg")
            },
            {
              coverPic: require("../assets/banner.jpg")
            },
            {
              coverPic: require("../assets/banner.jpg")
            },
            {
              coverPic: require("../assets/banner.jpg")
            },
            {
              coverPic: require("../assets/banner.jpg")
            }
          ];
        }
      });
    },
    getMyChart(list) {
      const chartDom = this.$refs.chart;
      const myChart = echarts.init(chartDom);
      // 指定图表的配置项和数据
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
        },
        xAxis: {
          data: list.map(item=>item.name),
          axisTick: {
            show: false  // 隐藏坐标轴刻度线
          },
        },
        yAxis: {},
        series: [{
          name: '数量',
          type: 'bar',
          data: list.map(item=>item.num),
          barWidth: 40,
        }]
      };
      myChart.setOption(option);
    },
    getMyChartLine(){
      axios.post('/cmsapi/getAccessLogBySeven').then(res=>{
        if(res.data&&res.data.length>0){
          const chartDom = this.$refs.chartLine;
          const myChart = echarts.init(chartDom);
          const option = {
            xAxis: [{
              type: 'category',
              axisLabel: {//坐标轴刻度标签
                show: false
              },
              axisLine: {//坐标轴轴线
                show: false
              },
              axisTick: {//坐标轴刻度
                show: false
              }
            }],
            yAxis: {
              type: 'value',
              splitLine: {//坐标轴在grid区域中的分割线
                show: false
              },
              axisLabel: {//坐标轴刻度标签
                show: false
              },
            },
            grid: {
              left: '0%',
              top:'20%',
              // bottom: '3%',
            },
            series: [
              {
                data: res.data,
                type: 'line'
              }
            ]
          };
          myChart.setOption(option);
          }
      })
    },
    changeTitle(index,c){
      this.activeTitleIndex = index
      this.type=c.type?c.type:'';
      this.currentPage=1
      this.selectEducoder()
    },
    changeActiveCourseItem(index,item){
      this.activeCourseIndex = index
      console.log(item,'item')
      if(item.url){
        window.open(item.url)
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.selectEducoder()

    },
    handleCurrentChange(val) {
        this.currentPage = val;
      this.selectEducoder()

    },
    initChinaMap(data) {
      const mapDom = this.$refs.chinaMap;
      this.mapChart = echarts.init(mapDom);
      const option = {
        tooltip: {
          trigger: 'item',
          // 根据数据动态生成 tooltip 内容
          formatter: function (params) {
            return `学员分布热力图<br/>${params.name} : ${params.value}`;
          }
        },
        visualMap: {
          min: 0,
          max: 60000,
          right: '10%',
          bottom: '10%',
          text: ['高', '低'],
          calculable: true,
          color: [ '#105C93','#ECF2FC',],
        },
        series: [
          {
            name: '中国地图',
            type: 'map',
            mapType: 'china',
            roam: false,
            label: {
              show: true
            },
            data: data,
            itemStyle: {
              // 省份边界线颜色
              borderColor: '#92B4CE',
            },
          }
        ]
      };
      this.mapChart.setOption(option);
      this.mapChart.resize()
    },
    selectEducoder(){
      let fd=new FormData()
      fd.append('page',this.currentPage)
      fd.append('limit',this.pageSize)
      fd.append('featured',this.type)
      axios.post('/cmsapi/selectEducoder',fd).then(res=>{
        if(res.data.data){
          let item = res.data.data
          console.log(item.open_subject_statistics.student_heat_map_statistics,'item')
          this.initChinaMap(item.open_subject_statistics.student_heat_map_statistics);
          this.carouselList = [
            {
              name:'实践课程',
              num:item.online_teaching_statistics.num,
              coverPic: require("../assets/sjkcsj.png")
            },
            {
              name:'实践项目',
              num:item.online_teaching_statistics.shixun_num,
              coverPic: require("../assets/sjxmsj.png")
            },
            {
              name:'关卡',
              num:item.online_teaching_statistics.challenge_num,
              coverPic: require("../assets/sjgk.png")
            },
            {
              name:'选用单位',
              num:item.online_teaching_statistics.school_used_num,
              coverPic: require("../assets/xydw.png")
            },
            {
              name:'学习人数',
              num:item.online_teaching_statistics.study_num,
              coverPic: require("../assets/sjxxrs.png")
            },
          ]
          // this.getMyChart(arr1)

          this.open_subject_statistics = item.open_subject_statistics
          this.online_exercise_statistics = item.online_exercise_statistics

          this.total = Number(item.subject_count)

          let arr2 = [
            {
              name:'全部课程',
              num:Number(item.subject_num),
              type:'',
            },
            {
              name:'国家一流课程',
              num:Number(item.national_subject_num),
              type:'1',
            },
            {
              name:'省级一流课程',
              num:Number(item.provincial_subject_num),
              type:'3',
            },
            {
              name:'其他课程',
              num:Number(item.other_subject_num),
              type:'-1',
            },
          ]
          this.kcList = arr2

          this.courseList = item.subjects
        }
      }).catch(err => {
        console.log(err)
      })
    },
  },
  mounted() {
    this.touGeUrl = this.$route.query.url
    this.selectEducoder()
    this.getMyChartLine()
    this.getAccessLogNum()
    window.addEventListener('resize', this.handleResize);
    this.handleResize(); // 初始化时执行一次
  }
}
</script>



<style scoped lang="less">
.panel{
  transform-origin: center;
  /* 确保子元素也按比例缩放 */
  width: calc(100% / var(--scale-factor));
  height: calc(100% / var(--scale-factor));
  transform: scale(var(--scale-factor));
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(var(--scale-factor));
}
.touGeBox{
  height: calc(100%- 170px);
  position: relative;
  .chartBox{
    width: 1200px;
    margin: 0 auto;
    background: rgba(255,255,255,0.5);
    .bar-chart {
      margin: 20px auto;
    }
  }
  .pubTitle {
    margin-top: 10px;
    font-weight: 700;
    font-size: 30px;
    color: #13499b;
    letter-spacing: 4px;
    text-align: center;
  }
  .backGroundDiv{
    position: absolute;
    width: 100%;
    background-size: 100% auto;
    background: url("../assets/TouGe/banner.png") no-repeat center;
    z-index: -99;
    height: 1800px;
    top: 500px;
  }
  .courseBox{
    width: 100%;
    margin:  0 auto;
    padding:0 160px;
    //height: 100%;
    .courseTitleBox{
      margin-top: 15px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #fff;
      height: 150px;
      //border-bottom: 1px solid #c3c7d0;
      cursor: pointer;
      .activeTitleItem{
        width: 25%;
        height: 100%;
        background-color: #105C93;
        z-index: 0;
        padding-top: 10px;
        border-bottom: 6px solid ;
        border-image: linear-gradient(270deg, #CED589 0%, #3A7CB5 54%, #FFFFFF 87%, #FFFFFF 100%) 1;
        padding-bottom: -1px;
        .Title{
          font-size: 54px;
          font-weight: 700;
          color: #fff;
          margin-top: 6px;
        }
        .className{
          margin-top: 6px;
          font-weight: 700;
          color: #fff;
          font-size: 20px
        }
        .shuiyin{
          display: block;
        }
      }
      .TitleItem{
        width: 25%;
        padding-top: 10px;
        z-index: 0;
        height: 100%;
        .Title{
          font-size: 54px;
          font-weight: 700;
          color: #333333;
          margin-top: 6px;
        }
        .className{
          margin-top: 6px;
          font-weight: 700;
          color: #105C93;
          font-size: 20px
        }
      }
    }
    .TitleItem:hover{
      width: 25%;
      height: 100%;
      z-index: 0;
      background-color: #105C93;
      padding-top: 10px;
      padding-bottom: -1px;
      border-bottom: 6px solid ;
      border-image: linear-gradient(270deg, #CED589 0%, #3A7CB5 54%, #FFFFFF 87%, #FFFFFF 100%) 1;
      .Title{
        font-size: 54px;
        font-weight: 700;
        color: #fff;
        margin-top: 6px;
      }
      .className{
        margin-top: 6px;
        font-weight: 700;
        color: #fff;
        font-size: 20px
      }
      .shuiyin{
        display: block;
      }
    }
    .courseContent{
      margin-top: 25px;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      //justify-content: space-between;
      .courseItem{
        position: relative;
        margin-bottom: 30px;
        height: 590px;
        width: 32%;
        margin-right: 2%;
        cursor: pointer;
        box-shadow: 0 6px 12px 0 #0000001f;
        img{
          width: 100%;
          height: 240px;
        }
        .itemBottom{
          padding: 15px 30px;
          height: 350px;
          width: 100%;
          background-color: #fff;
          .itemTitle{
            width: 100%;
            display: flex;
            //align-items: center;
            //justify-content: space-between;
          }
          .num{
            color: #176DAA;
            font-weight: 700;
            font-size: 18px;
          }
          .key{
            color: #666;
            margin-top: 6px;
          }
        }
      }
    }
    .courseItem:hover .itemBottom{
      color: #fff;
      background-color:#176DAA !important;
      p{
        color: #fff !important;
      }
    }

    .courseItem:hover .shuiyin2{
      display: block;
    }
    .activeCourseItem{
      position: relative;
      color: #fff !important;
      background-color:#176DAA !important;
      margin-bottom: 30px;
      height: 590px;
      width: 32%;
      margin-right: 2%;
      cursor: pointer;
      box-shadow: 0 6px 12px 0 #0000001f;
      img{
        width: 100%;
        height: 240px;
      }
      .itemBottom{
        padding: 15px 30px;
        height: 350px;
        width: 100%;
        .itemTitle{
          width: 100%;
          display: flex;
          //align-items: center;
          //justify-content: space-between;
        }
        .num{
          font-weight: 700;
          font-size: 18px;
        }
        .key{
          margin-top: 6px;
        }
      }
      p{
        color: #fff !important;
      }
      .shuiyin2{
        display: block;
      }
    }
    .dividerBlue{
      display: block;
      width: 2px;
      height: 40px;
      background-color: #13499b;
    }
    .dividerWhite{
      display: block;
      width: 2px;
      height: 40px;
      background-color: #fff;
    }
    .dividerYellow{
      display: block;
      width: 2px;
      height: 40px;
      background-color: #ba7915;
    }
    .dividerGreen{
      display: block;
      width: 2px;
      height: 40px;
      background-color: #57a7ae;
    }
    .courseItem:nth-child(3n){
      margin-right: 0 !important;
    }
    .activeCourseItem:nth-child(3n){
      margin-right: 0 !important;
    }
    .itemTop{
      position: relative;
    }
    .subscript{
      position: absolute;
      top: 0;
      left: 0;
      width: 80px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      border-radius: 0 0 16px 0;
      background-color: #13499b;
      color: #fff;
    }
    .subscript1{
      position: absolute;
      top: 0;
      left: 0;
      width: 80px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      border-radius: 0 0 16px 0;
      background-color: #bb7915;
      color: #fff;
    }
    .subscript2{
      position: absolute;
      top: 0;
      left: 0;
      width: 80px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      border-radius: 0 0 16px 0;
      background-color: #56a7af;
      color: #fff;
    }
  }
  .pubTitles {
    color: #13499b;
    font-size: 16px;
    font-weight: 700;
    text-align: center;
  }
  .oneTitle {
    //height: 100%;
    width: 500px;
    height: 110px;
    padding-top: 15px;
    background: url("../assets/title.png") no-repeat center;
    margin: auto;
  }
  .systemBox{
    position: absolute;
    right: 100px;
    top: 550px;
    color: #002b9e;
    font-size: 20px;
    cursor: pointer;
  }
}
.bottomLink {
  height: 60px;
  width: 100%;
  /* width: calc(100% - 520px); */
  background: #105C93;
  color: #fff;
}
.bottomLinkList {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 280px;
  position: relative;
}
.bottomLinkList:not(:last-child)::after {
  content: "";
  width: 1px;
  height: 24px;
  opacity: 0.2;
  background-color: #fff;
  position: absolute;
  right: 0;
}
.linkDivider .el-divider--vertical {
  height: 24px !important;
  background-color: #3f6bae !important;
  width: 1.5px !important;
  margin: 0 30px 36px 30px !important;
}
.copyDiv {
  height: 300px;
  /* width: calc(100% - 520px); */
  padding: 40px 260px;
  background: url("../assets/bottomBgs.png") no-repeat;
  background-size: 100% 100%;
}
.copyDivLeftCon {
  opacity: 0.8;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0;
  margin-top: 16px;
}
.shuiyin{
  background: url("../assets/shuiyin.png") no-repeat center;
  background-size: 100% 100%;
  display: none;
  z-index: -2;
}
.shuiyin2{
  background: url("../assets/shuiyin2.png") no-repeat center;
  background-size: 100% 100%;
  display: none;
}
.shuiyin3{
  background: url("../assets/shuiyin3.png") no-repeat center;
  background-size: 100% 100%;
  z-index: -1;
}
.el-carousel__item {
  border-radius: 14px !important;
}
.el-carousel__item--card {
  width: 1290px;
  margin-left: -9%;
}
</style>
